import Vue from 'vue'
import App from './App.vue'
import 'lib-flexible/flexible'
import router from './router'
import store from './store'
import myAxios from './assets/api/axios';
import myAxios1 from './assets/api/axios1';
import myAxios2 from './assets/api/axios2';
import helper from './assets/api/tool';
import nativeApi from './assets/api/nativeApi' //原生接口封装
import bridge from './assets/api/dsbridge' //dsBridge引用
import SwBase from './assets/api/SwBase'; //单一封装JS
//import Sw64 from './assets/api/SwCaHu';
//import md5 from './assets/api/md5'
import './assets/css/icon.scss'
import {
  Toast,
  Dialog
} from 'vant';

import Vconsole from 'vconsole';

import { cq } from'./base/common/utils/cq/index'
//Vue.config.productionTip = false
Vue.use(cq)

Vue.prototype.$http = myAxios
Vue.prototype.$http1 = myAxios1
Vue.prototype.$http2 = myAxios2
Vue.prototype.$tool = helper
Vue.prototype.$base = SwBase
//Vue.prototype.$sw64 = Sw64
//Vue.prototype.$md5 = md5
Vue.prototype.$toast = Toast
Vue.prototype.$dialog = Dialog

let str = window.location.href

let index = str.indexOf("apptest.singlewindow.cn")
if (index > -1) {
  Vue.prototype.$vConsole = new Vconsole()
}
Vue.prototype.$nativeApi = nativeApi
Vue.prototype.bridge = bridge
router.beforeEach((to, from, next) => {
  window.document.title = to.meta.title == undefined ? 'singlewindow' : to.meta.title
  if (to.path === '/' && from.path !== '/') {
    helper.callModule('hidenTabBar', false)
  }
  next()
})

var vue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


export default vue